import { INTEGRATIONS } from "./landing-data";

export function LandingIntegrations() {
  return (
    <section
      id="integrasjoner"
      className="scroll-mt-24 border-t border-slate-200 bg-white py-20 sm:py-28"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <p className="text-sm font-semibold uppercase tracking-wider text-sky-600">
            Integrasjoner
          </p>
          <h2 className="mt-3 text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
            Koblet til verktøyene dere allerede bruker
          </h2>
          <p className="mt-4 text-lg text-slate-600">
            Mindre manuell overføring — mer tid til faktisk leveranse.
          </p>
        </div>

        <div className="mt-14 grid gap-6 sm:grid-cols-2">
          {INTEGRATIONS.map((integration) => (
            <div
              key={integration.name}
              className="rounded-2xl border border-slate-200 p-6 transition hover:border-sky-200 hover:shadow-md"
            >
              <div className="flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-slate-900 text-sm font-bold text-white">
                  {integration.name.charAt(0)}
                </span>
                <h3 className="text-lg font-semibold text-slate-900">
                  {integration.name}
                </h3>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-slate-600">
                {integration.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
